// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2Evzu","clinicsSelect":"TableHeading_clinicsSelect__kl86v"};